module.exports = __webpack_public_path__ + "img/klarna.6724adc8.svg";